// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"7f1ff527","410":"4c4e7674","510":"d07d884e","629":"947744b2","936":"210e30a3","947":"ddaa8ba7"}[chunkId] + ".chunk.js";
};